import React from 'react';
import {Stack} from '@mui/material';
import JsonView from '@uiw/react-json-view';
import {githubLightTheme} from '@uiw/react-json-view/githubLight';

const SCJsonView = props=>{
    let {value} = props;
    return <Stack sx={{direction: 'ltr', overflow: 'auto'}}>
      <JsonView value={value}
        style={githubLightTheme}/>
    </Stack>;
};

export default SCJsonView;
